import React from "react";
import styled from "styled-components";

export const BurgerButtonWrapper = styled.div`
	& {
		width: 20px;
		height: 15px;
		position: relative;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: 0.6s ease;
		-moz-transition: 0.6s ease;
		-o-transition: 0.6s ease;
		transition: 0.6s ease;
		cursor: pointer;
	}

	span {
		display: block;
		position: absolute;
		height: 2.5px;
		width: 100%;
		background: ${({theme}) => theme.colors.primary};
		border-radius: 2.5px;
		opacity: 1;
		left: 0;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: 0.35s ease;
		-moz-transition: 0.35s ease;
		-o-transition: 0.35s ease;
		transition: 0.35s ease;
	}
	.open {
		height: 2px;
	}
	span:nth-child(1) {
		top: 0px;
	}

	span:nth-child(2),
	span:nth-child(3) {
		top: 7px;
	}

	span:nth-child(4) {
		top: 14px;
	}

	.open:nth-child(1) {
		top: 7px;
		width: 0%;
		left: 50%;
	}

	.open:nth-child(2) {
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.open:nth-child(3) {
		-webkit-transform: rotate(-45deg);
		-moz-transform: rotate(-45deg);
		-o-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}

	.open:nth-child(4) {
		top: 7px;
		width: 0%;
		left: 50%;
	}
`;